var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "400px" },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "secondary white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "header-font",
                          staticStyle: { "font-size": "22px" },
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.title)))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "v-container",
                        { staticClass: "pa-0" },
                        [
                          _c("p", { staticClass: "body-1 primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("login.forgotPasswordMessage"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            {
                              ref: "formRef",
                              attrs: { name: "form" },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onSaveClick.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-1",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "body-1 font-weight-bold primary--text pb-1 mb-0",
                                        },
                                        [_vm._v("Email")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          placeholder: " ",
                                          rules: _vm.emailRules,
                                        },
                                        model: {
                                          value: _vm.user.email,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.user, "email", $$v)
                                          },
                                          expression: "user.email",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "pr-6 pb-4 d-flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "elevation-0 monospace-font px-4",
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "white"
                              : "secondary",
                            rounded: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onCancelClick()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "elevation-0 monospace-font white--text px-4",
                          attrs: { rounded: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSaveClick()
                            },
                          },
                        },
                        [_vm._v("OK")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }